import en from './trans_en';
import tw from './trans_tw';
import cn from './trans_cn';

export const Language = {
    'en': {
        message: en,
        name: 'EN'
    },
    'zh-TW': {
        message: tw,
        name: 'TC'
    },
    'zh-CN': {
        message: cn,
        name: 'SC'
    }
}